import { default as swal } from 'sweetalert2'

module.exports = {
  success: function (text) {
    swal({
      html: '<span style="color: #fff; font-weight: 500; font-size: 20px; margin-top: -10px; display: inline-block;">' + text + '</span>',
      type: 'success',
      background: '#2ecc71',
      customClass: 'swal-white-icons',
      toast: true,
      padding: '10px 35px 5px',
      position: 'bottom-right',
      imageHeight: 55,
      showConfirmButton: false,
      timer: 5000
    })
  },
  warn: function (text) {
    swal({
      html: '<span style="color: #fff; font-weight: 500; font-size: 20px; margin-top: -10px; display: inline-block;">' + text + '</span>',
      type: 'error',
      background: '#E9573F',
      customClass: 'swal-white-icons',
      toast: true,
      padding: '10px 35px 5px',
      position: 'bottom-right',
      imageHeight: 55,
      showConfirmButton: false,
      timer: 5000
    })
  },
  confirm: function (text, options) {
    if (!options) options = {}
    return new Promise((resolve, reject) => {
      swal({
        title: 'Are you sure?',
        text: text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Delete',
        closeOnConfirm: false,
        ...options
      }).then(confirmed => {
        resolve(!confirmed.dismiss)
      })
    })
  },
  deleteConfirm: function (text, callback) {
    swal({
      title: 'Are you sure?',
      text: text,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Delete',
      closeOnConfirm: false
    }).then(confirmed => {
      // eslint-disable-next-line
      if (confirmed.dismiss) return callback(false)
      // eslint-disable-next-line
      callback(true)
    })
  },
  alert: function (head, text, type) {
    swal(head, text, type)
  },
  html: function(title, html, type) {
    swal.fire({
      title: title,
      html: html,
      type: type
    })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/notify.js